export const en = {
    'any-days-selected': {
        one: '{count} day per week',
        some: '{count} days per week',
        many: '{count} days per week',
        none: '{count} days per week'
    },
    'arbitrary-time': 'Any',
    daily: 'Daily',
    'error-min-count-working-days': {
        one: 'The campaign must be active at least {count} hour on business days',
        some: 'The campaign must be active at least {count} hours on business days',
        many: 'The campaign must be active at least {count} hours on business days',
        none: 'The campaign must be active at least {count} hours on business days'
    },
    friday: 'Fri',
    hour24: '24×7',
    monday: 'Mon',
    'not-show': 'Do not serve',
    'range-time': 'Range',
    saturday: 'Sat',
    show: 'Serve',
    sunday: 'Sun',
    thursday: 'Thu',
    tuesday: 'Tue',
    wednesday: 'Wed',
    weekdays: 'On weekdays',
    weekends: 'On weekends',
    'work-time': 'Working hours'
};
